import React from 'react'
import classNames from 'classnames'
import { CMSImage } from '@/ui/atoms/CMSImage'
import { Label } from '@/ui/atoms/Label'

type TeaserCardSkeletonProps = {
  className?: string
}

export const TeaserCardSkeleton: React.FC<TeaserCardSkeletonProps> = ({
  className: classNameFromProps,
}) => {
  return (
    <div
      className={classNames(
        'flex flex-row justify-start items-center rounded-md overflow-hidden bg-bg-subtle p-2 gap-4',
        classNameFromProps,
      )}
    >
      <div className="animate-pulse relative min-w-[120px] aspect-4/3 overflow-hidden bg-neutral-90 rounded-sm"></div>
      <div className={'w-full'}>
        <div className="animate-pulse relative w-1/2 h-5 mb-2 bg-neutral-90 rounded-sm"></div>
        <div className="animate-pulse relative w-3/4 h-3 mb-1 bg-neutral-90 rounded-sm"></div>
        <div className="animate-pulse relative w-2/3 h-3 bg-neutral-90 rounded-sm"></div>
      </div>
    </div>
  )
}
